import { render, staticRenderFns } from "./contratoDetalhesInformacao.vue?vue&type=template&id=5fd041bb"
import script from "./contratoDetalhesInformacao.vue?vue&type=script&lang=js"
export * from "./contratoDetalhesInformacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports